import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Avatar } from "antd";
import AddServiceProviders from "./AddServiceProviders";
import { Error } from "../../../commons/Messages/Messages";
import axios from "axios";
import EditServiceProviders from "./EditServiceProviders";
import DeleteModal from "../../../commons/DeleteModal/DeleteModal";
import SelectComp from "../../../commons/Select/Select";
import defaultImage from "../../../commons/PanelAssets/img/doctors/doctor-01.jpg";
import GeneralTable from "../../../commons/GeneralTable";
import SearchBarComp from "../../../commons/SearchBar/SearchBar";
import DropdownComp from "../../../commons/Dropdowns/DropdownComp";
import PageToolbar from "../../../design-system/PageToolbar";
import "./ServiceProviders.css";

import { useTranslation } from "react-i18next";
const ServiceProvidersList = () => {
  const { t } = useTranslation("dashboard");
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState("");
  const [searchText, setSearchText] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(6);

  const handleSearch = value => {
    setSearchText(value);
    setPageNo(1);
  };

  const columns = [
    {
      title: t("Name"),
      dataIndex: "name",
      mobile: "title",
      render: (text, record) => (
        <Link to="" className="service-providers-page__person">
          <Avatar size={40} src={record.picture ? record.picture?.url : defaultImage} alt="" />
          <span>
            {record.firstName} {record.lastName}
          </span>
        </Link>
      ),
      sorter: (a, b) => a.firstName.localeCompare(b.firstName)
    },
    {
      title: t("Logo"),
      dataIndex: "logo",
      render: (text, record) => (
        <Avatar
          shape="square"
          size={48}
          className="service-providers-page__logo"
          src={record.logo ? record.logo?.url : defaultImage}
          alt=""
        />
      ),
      sorter: (a, b) => a.firstName.localeCompare(b.firstName)
    },
    {
      title: t("ServiceProvider ID"),
      dataIndex: "serviceProviderId",
      sorter: (a, b) => a.employee_id.length - b.employee_id.length
    },
    {
      title: t("Email"),
      dataIndex: "email",
      sorter: (a, b) => a.email.length - b.email.length
    },
    {
      title: t("Mobile"),
      dataIndex: "phone",
      sorter: (a, b) => a.mobile.length - b.mobile.length
    },
    {
      title: t("Company"),
      dataIndex: "companyName",
      sorter: (a, b) => a.companyName.length - b.companyName.length
    },
    {
      title: t("Status"),
      dataIndex: "status",
      render: text => (
        <div className="service-providers-page__status">
          <SelectComp
            handleChange={() => undefined}
            value="Active"
            options={[
              {
                value: "Active",
                label: t("Active")
              },
              {
                value: "Inactive",
                label: t("Inactive")
              }
            ]}
          />
        </div>
      )
    },
    {
      title: t("Action"),
      key: "action",
      render: (text, obj) => {
        const menuItems = [
          {
            key: "view",
            link: `/user/projects/${obj?._id}`
          },
          {
            key: "edit",
            component: () => <EditServiceProviders data={obj} updateParent={getData} />
          },
          {
            key: "delete",
            component: () => <DeleteModal text="ServiceProvider" onClick={() => undefined} />
          }
        ];
        return (
          <div>
            <DropdownComp menuItems={menuItems} />
          </div>
        );
      }
    }
  ];

  const getData = async () => {
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/service-providers/all`,
        { searchText, pageSize, pageNo: pageNo - 1 },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          setData(res.data?.data);
          setTotalCount(res.data?.count);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        if (err.response?.data?.errorMessage) {
          Error(err.response?.data?.errorMessage);
        } else {
          Error(err.message);
        }
      });
  };

  useEffect(() => {
    getData();

    return () => {};
  }, [pageNo, searchText]);

  return (
    <div className="service-providers-page">
      <PageToolbar
        filters={<SearchBarComp handleSearch={handleSearch} />}
        actions={<AddServiceProviders updateParent={getData} />}
      />
      <GeneralTable
        pageNo={pageNo}
        pageSize={pageSize}
        totalCount={totalCount}
        data={data}
        columns={columns}
        setPageNo={setPageNo}
      />
    </div>
  );
};

export default ServiceProvidersList;
